import { refreshCourseAfterAct } from "@/lib/course-query-keys";
import type { QueryClient } from "@tanstack/react-query";

import { refreshHomeAfterAct } from "@/lib/home-query-keys";

/** Canonical readback, never a local count/rank patch. Inactive class reads are
 * invalidated too so returning to the exact class cannot show old coursework.
 */
export function invalidateAssignment(client: QueryClient, courseId: string, assignmentId: string) {
  refreshHomeAfterAct(client);
  return Promise.all([
    client.invalidateQueries({ queryKey: ["assignments", courseId] }),
    client.invalidateQueries({ queryKey: ["native-coursework", courseId] }),
    client.invalidateQueries({ queryKey: ["assignment", assignmentId] }),
    client.invalidateQueries({ queryKey: ["assignment-sheet", courseId, assignmentId] }),
    refreshCourseAfterAct(client, courseId),
    client.invalidateQueries({ queryKey: ["session-workspace"] }),
    client.invalidateQueries({ queryKey: ["course-content"] }),
  ]);
}

/** A removed draft: its own reads are dropped rather than refetched into a 404,
 * and every list that named it reads again.
 */
export function forgetAssignment(client: QueryClient, courseId: string, assignmentId: string) {
  client.removeQueries({ queryKey: ["assignment", assignmentId] });
  client.removeQueries({ queryKey: ["assignment-sheet", courseId, assignmentId] });
  refreshHomeAfterAct(client);
  return Promise.all([
    client.invalidateQueries({ queryKey: ["assignments", courseId] }),
    client.invalidateQueries({ queryKey: ["native-coursework", courseId] }),
    refreshCourseAfterAct(client, courseId),
    client.invalidateQueries({ queryKey: ["session-workspace"] }),
    client.invalidateQueries({ queryKey: ["course-content"] }),
  ]);
}
